(function($) {
  // hover fade button
  $(".fade, #header a img, #dropArea a img, #container a img, #carLineup a img, #cmnArea a img, #footer a img, .rBtn01, .rBtn02, .sendArea input, .sendArea02 input, .rsBtn01").hover(function() {
    $(this).fadeTo(10, 0.7);
  }, function() {
    $(this).fadeTo(300, 1.0);
  });
  // トップへスクロール
  var topBtn = $('#page-top');
  topBtn.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
  });
  // minimalect (http://groenroos.github.io/minimalect/)
  if ($.fn.minimalect) {
    setTimeout(function() {
      $('select.minimalect').each(function() {
        var $select = $(this);
        // 既にminimalectが初期化されている場合は破棄
        if ($select.data('minimalect')) {
          $select.minimalect('destroy');
        }
        var currentValue = $select.val();
        // 初期化前に値をリセット
        if (!currentValue || currentValue === '') {
          $select.val('');
        }
        $select.minimalect({
          placeholder: '選択してください',
          onchange: function(value) {
            if (value === '') return; // 空の値の場合は何もしない
            var url = window.location.href;
            if (window.location.search) {
              if (window.location.search.indexOf('selected=') != -1) {
                url = url.replace(/selected=\d+/, 'selected=' + value);
                window.location = url;
              } else if (window.location.search.indexOf('?') != -1) {
                window.location = url + '&selected=' + value;
              }
            } else {
              window.location = url + '?selected=' + value;
            }
          }
        });
      });
    }, 100); // 100ms遅延して初期化
  }
  // 車種選択時の背景色変更機能
  function initCarClassSelection() {
    var $carRadios = $('.js-car-class-radio');

    if ($carRadios.length > 0) {
      // ラジオボタンの変更イベント
      $carRadios.on('change', function() {
        // 全ての車種テーブルからselectedクラスを削除
        $('.js-car-class-table').removeClass('selected');

        // 選択された車種のテーブルにselectedクラスを追加
        if (this.checked) {
          $(this).closest('.js-car-class-table').addClass('selected');
        }
      });

      // テーブル全体のクリックで選択できるようにする
      $('.js-car-class-table').on('click', function(e) {
        // ラジオボタン自体のクリックの場合は重複処理を避ける
        if (e.target.type === 'radio') {
          return;
        }

        var $radio = $(this).find('.js-car-class-radio');
        if ($radio.length > 0) {
          $radio.prop('checked', true).trigger('change');
        }
      });

      // ページ読み込み時に既に選択されているラジオボタンがあれば適用
      var $checkedRadio = $carRadios.filter(':checked');
      if ($checkedRadio.length > 0) {
        $checkedRadio.closest('.js-car-class-table').addClass('selected');
      }
    }
  }

  // フォーム二重送信防止
  function initPreventDoubleSubmit() {
    $('form').on('submit', function() {
      var $form = $(this);
      if ($form.data('submitted')) {
        return false;
      }
      $form.data('submitted', true);
      $form.find('input[type="submit"], input[type="image"]').each(function() {
        $(this).css('opacity', '0.5').css('pointer-events', 'none');
      });
    });
  }

  // ページ読み込み時に初期化
  $(document).ready(function() {
    // 車種選択機能を初期化
    initCarClassSelection();
    // フォーム二重送信防止を初期化
    initPreventDoubleSubmit();
  });
})(jQuery);
